import { ChangeEvent, FunctionComponent } from "react";
import { SingleValue } from "react-select";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import "./styles.scss";
import { Icon } from "../Icon";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import useModal from "../../utils/hooks/useModal";
import Button from "../common/Button";
import { labelColor } from "../AddVariant/util";

type Props = {
  modalType: "custom" | "variants" | null;
  customization: string | undefined;
  setCustomization: (value: string) => void;
  incomplete: boolean;
  exist: boolean;
  variation: Variation;
  colors: string[];
  lengths: string[];
  gauges: string[];
  restItem: (e: any) => void;
  sumItem: (e: any) => void;
  handleChange: (e: any) => void;
  handleCreateCustomization: (newCustomization: string | undefined) => void;
  addOneProduct: CartProduct;
  addPreCart: () => void;
  handleSelectChange: (
    option: SingleValue<{ value: string; label: string }>,
    e: any
  ) => void;
  closeModal: () => void;
  handleNativeSelectChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  setIsLoginRequired: (value: boolean) => void;
  isLoginRequired: boolean;
  isAuth: boolean;
};

const VariantsAndCustomModal: FunctionComponent<Props> = ({
  incomplete,
  exist,
  variation,
  colors,
  lengths,
  gauges,
  restItem,
  sumItem,
  handleChange,
  addOneProduct,
  addPreCart,
  handleSelectChange,
  handleNativeSelectChange,
  handleCreateCustomization,
  closeModal,
  modalType,
  customization,
  setCustomization,
  isAuth,
  setIsLoginRequired,
  isLoginRequired,
}) => {
  const { isOpen, toggle } = useModal();
  const location = useLocation();
  const handleAddPreCart = () => {
    if (!isAuth) {
      setIsLoginRequired(true);
      return;
    }
    addPreCart();
  };

  const handleClose = () => {
    clearAllBodyScrollLocks();
    toggle();
    closeModal();
  };

  // react-select data:

  // const options = (param: string[]) =>
  //   param.map((option) => {
  //     return { label: option, value: option };
  //   });
  // const customStyles = {
  //   control: (base: CSSObjectWithLabel) => ({
  //     ...base,
  //     boxShadow: "none",
  //     borderRadius: 30,
  //     fontFamily: "Mont-SemiBold",
  //     fontSize: 16,
  //     fontWeight: "normal",
  //     width: "100%",
  //     padding: "10px",
  //   }),
  //   option: (base: CSSObjectWithLabel, state: any) => ({
  //     ...base,
  //     cursor: "pointer",
  //     color: state.isSelected ? "white" : "#221F28",
  //     backgroundColor: state.isSelected
  //       ? "#b6966d"
  //       : state.isFocused && "#F5F5F5",
  //     fontFamily: "Mont-Regular",
  //     fontSize: 14,
  //   }),
  // };

  const selectOptionsDefault =
    (addOneProduct.department === "chain" ||
      addOneProduct.department === "brazalete") &&
    (!addOneProduct?.category?.includes("pendant") ||
      !addOneProduct?.category?.includes("rock") ||
      !addOneProduct?.category?.includes("hollow") ||
      !addOneProduct?.category?.includes("hoop") ||
      !addOneProduct?.category?.includes("finding"))
      ? { gaugeLabel: "Hilo", lengthLabel: "Largo" }
      : { gaugeLabel: "Espesor", lengthLabel: "Medidas" };

  let approximateWeight =
    Number(addOneProduct.weight.replace(",", ".")) * addOneProduct.quantity;

  approximateWeight = Number(approximateWeight.toFixed(2));
  const hasSingleColor = colors.length === 1;
  const getColorLabel = (color: string) => {
    const formattedLabel = labelColor(color);
    if (formattedLabel === "Seleccionar") {
      return color.charAt(0).toUpperCase() + color.slice(1);
    }
    return formattedLabel;
  };

  return (
    <section className="variants_mobile_container">
      <form className="variants_mobile_form">
        <div className="variant_mobile_header">
          <p className="variants_mobile_title">
            {modalType === "variants"
              ? "Elegir variantes"
              : modalType === "custom"
              ? "Personalizado"
              : null}
          </p>
          <button onClick={closeModal} className="variants_mobile_button">
            <Icon iconName="close_x_icon" />
          </button>
        </div>
        {modalType === "variants" ? (
          <>
            {hasSingleColor ? (
              <p className="variants_mobile_silver">
                <span></span>
                {getColorLabel(colors[0])}
              </p>
            ) : (
              <div className="nativeSelect_container">
                <Icon iconName="down_arrow" className="nativeSelect_arrow" />
                <select
                  className="variants_mobile_select variants_mobile_nativeSelect"
                  onChange={(event) => handleNativeSelectChange(event)}
                  name="color"
                  value={variation.color}
                >
                  <option value="" disabled>
                    Color
                  </option>
                  {colors.map((option, i) => (
                    <option key={i} value={option}>
                      {getColorLabel(option)}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="nativeSelect_container">
              <Icon iconName="down_arrow" className="nativeSelect_arrow" />
              <select
                className="variants_mobile_select variants_mobile_nativeSelect"
                onChange={(event) => handleNativeSelectChange(event)}
                name="gauge"
                value={variation.gauge}
              >
                <option value="" disabled>
                  {selectOptionsDefault.gaugeLabel}
                </option>
                {gauges.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="nativeSelect_container">
              <Icon iconName="down_arrow" className="nativeSelect_arrow" />
              <select
                className="variants_mobile_select variants_mobile_nativeSelect"
                onChange={(event) => handleNativeSelectChange(event)}
                name="length"
                value={variation.length}
              >
                <option value="" disabled>
                  {selectOptionsDefault.lengthLabel}
                </option>
                {lengths.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="variants_mobile_quantity">
              <p>Cantidad</p>
              <button
                onClick={restItem}
                type={"button"}
                className="variants_mobile_btn"
              >
                -
              </button>
              <input
                type={"text"}
                name="quantity"
                value={addOneProduct.quantity}
                onChange={handleChange}
              ></input>
              <button
                onClick={sumItem}
                type={"button"}
                className="variants_mobile_btn"
              >
                +
              </button>
            </div>
            <div className="variants_mobile_total">
              <p>
                Peso
                <span>{approximateWeight}gr</span>
              </p>
              <p>
                Hechura
                <span>
                  {addOneProduct.manufacturValue == 0
                    ? "-"
                    : "$" +
                      Number(addOneProduct.manufacturValue) *
                        addOneProduct.quantity}
                </span>
              </p>
            </div>

            <button
              onClick={handleAddPreCart}
              className={classNames(
                addOneProduct.weight
                  ? "variants_mobile_add"
                  : "variants_mobile_add_disabled variants_mobile_add"
              )}
              type={"button"}
              disabled={addOneProduct.weight ? false : true}
            >
              Agregar variantes
            </button>
            {incomplete && (
              <p className="itemDetail_data_msg">
                Seleccione una combinación válida. Si desea proponer una nueva
                variante, escribanos <Link to={"/contact"}>aquí</Link>!
              </p>
            )}
            {isLoginRequired && (
              <p className="itemDetail_data_msg">
                Para agregar productos al carrito, primero iniciá sesión{" "}
                <Link to={"/login"} state={{ from: location.pathname }}>
                  haciendo click aquí
                </Link>
              </p>
            )}
            {exist && (
              <p className="itemDetail_data_msg">
                El producto ya esta en el carrito
              </p>
            )}
          </>
        ) : modalType === "custom" ? (
          <div className="customizationContainerMobile">
            <p className="customizationTitleMobile">{addOneProduct.title}:</p>
            <textarea
              className="customizationInputMobile"
              id="customization"
              name="customization"
              value={customization}
              placeholder="Ingrese la personalización"
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                setCustomization(e.target.value)
              }
            ></textarea>
            <div className="customizationButtonsMobile">
              <Button
                disabled={(customization?.length ?? 0) === 0}
                applyNewSize
                className="customizationButtons_gold"
                type="button"
                onClick={() => {
                  handleCreateCustomization(customization);
                  handleClose();
                }}
              >
                {"Guardar"}
              </Button>
              <Button
                applyNewSize
                modifier="tertiary"
                className="customizationButtons_white"
                type="button"
                onClick={() => {
                  setCustomization("");
                  handleCreateCustomization("");
                }}
              >
                {"Borrar"}
              </Button>
            </div>
          </div>
        ) : null}
      </form>
    </section>
  );
};

export default VariantsAndCustomModal;
